import { isMemoryConstrained } from "./memory_policy.js";

type SavedCanvas = { width: number; height: number; transform: DOMMatrix | null };

const saved = new WeakMap<HTMLCanvasElement, SavedCanvas>();

export const releaseHiddenCanvas = ( canvas: HTMLCanvasElement ): void =>
{
  if ( !isMemoryConstrained() || canvas.width <= 1 || canvas.height <= 1 )
    return;

  const ctx = canvas.getContext( "2d" );
  saved.set( canvas, {
    width: canvas.width,
    height: canvas.height,
    transform: ctx ? ctx.getTransform() : null,
  } );
  canvas.width = 1;
  canvas.height = 1;
};

export const restoreReleasedCanvas = ( canvas: HTMLCanvasElement ): void =>
{
  const state = saved.get( canvas );
  if ( !state )
    return;

  saved.delete( canvas );
  if ( canvas.width !== 1 || canvas.height !== 1 )
    return;

  canvas.width = state.width;
  canvas.height = state.height;
  if ( state.transform )
    canvas.getContext( "2d" )?.setTransform( state.transform );
};
